export default {
      id: "ic_google-usage",
      viewBox: "0 0 24 24",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic_google-usage",
      toString: function () {
        return this.url;
      }
    }